var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon-Delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.003,
    height: 20,
    viewBox: "0 0 20.003 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-Delete-2",
    "data-name": "Icon-Delete",
    d: "M715.013,1003.1l-8-8.115,7.76-7.868a1.18,1.18,0,0,0-1.678-1.658l-7.74,7.846-7.738-7.846a1.18,1.18,0,0,0-1.68,1.658l7.762,7.868-8,8.115a1.181,1.181,0,0,0,.84,2.009,1.192,1.192,0,0,0,.84-.351l7.98-8.093,7.982,8.093a1.18,1.18,0,0,0,1.68-1.658Z",
    transform: "translate(-695.35 -985.106)",
    fill: "#336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/Icon-Delete.4accfa82e91e11ef113244eec62e0783.svg";
export { ForwardRef as ReactComponent };